import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBtVideoPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 74,
	height: 74,
	viewBox: "0 0 74 74",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .75,
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 74,
			height: 74,
			rx: 37,
			fill: "#D9DADC"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M56.3527 35.6612L28.834 11.9292C27.8078 11.0475 26.3047 11.8424 26.3047 13.2661V60.7301C26.3047 62.1538 27.8078 62.9487 28.834 62.0671L56.3527 38.335C57.1404 37.6557 57.1404 36.3405 56.3527 35.6612Z",
			fill: "#0A0B0C"
		})]
	})
});
export default SvgBtVideoPlay;
